<template>
   <div class="view-course-details container-fluid"> 
        <div id="myNav" class="overlay overlay-overall-width-100Perc">
          <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
              <div class="row">
                <div class="col-md-12 col-lg-12">
                  <div class="text-right close-text-font-style margin-right-1Point2Perc cursor-pointer" v-on:click="udpateCloseViewCourseDetailOverlay($event)">
                    <img src= "../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-1Perc float-right" alt="close-icon">
                  </div>  
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="font-size-17px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Title:
                </div>
                <div class="font-size-17px col-md-8 col-lg-8 text-align-left">
                  {{CourseTitleValue}}
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="font-size-17px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Sub-Title:
                </div>
                <div class="font-size-17px col-md-8 col-lg-8 text-align-left">
                  {{CourseSubTitleValue}}
                </div> 
                <div class="col-md-1 col-lg-1">
                </div> 
              </div>
              <div class="row vertical-align margin-bottom-2Perc" v-if="isComingFrom === constants.CourseSearchBarEnum.Course">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="font-size-17px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Version:
                </div>
                <div class="font-size-17px col-md-8 col-lg-8 text-align-left">
                  {{CourseVersionValue}}
                </div> 
                <div class="col-md-1 col-lg-1">
                </div> 
              </div>
              <div class="row vertical-align margin-bottom-2Perc" v-if="isComingFrom === constants.CourseSearchBarEnum.AssessmentJourney">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="font-size-17px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Description:
                </div>
                <div class="font-size-17px col-md-8 col-lg-8 text-align-left">
                  <span v-html="CourseDescriptionValue"></span>
                </div> 
                <div class="col-md-1 col-lg-1">
                </div> 
              </div>
              <div class="row vertical-align margin-bottom-2Perc" v-if="isComingFrom === constants.CourseSearchBarEnum.Course">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="font-size-17px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Course Type:
                </div>
                <div class="font-size-17px col-md-8 col-lg-8 text-align-left">
                  {{CourseTypeValue}}
                </div> 
                <div class="col-md-1 col-lg-1">
                </div> 
              </div>
              <!--
              <div class="row vertical-align margin-bottom-2Perc"> 
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="font-size-17px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Is Enabled:
                </div>
                <div class="font-size-17px col-md-8 col-lg-8 text-align-left">
                  <label><input type="checkbox" v-model="IsEnabledCourseValue" disabled></label>
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
              </div>
              -->
              <div class="row vertical-align margin-bottom-2Perc" v-if="isComingFrom === constants.CourseSearchBarEnum.Course"> 
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="font-size-17px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Toolkit File:
                </div>
                <div class="font-size-17px col-md-8 col-lg-8 text-align-left" v-if="ToolkitFileUrlValue !== null && ToolkitFileUrlValue !== undefined">
                  <!-- <a :href="ToolkitFileUrlValue">Download File</a> -->
                  <a type="button" class="btn btn-default btn-sm" :href="ToolkitFileUrlValue">
                    <span class="glyphicon glyphicon-download"></span> Download
                  </a>
                </div>
                <div class="font-size-17px col-md-8 col-lg-8 text-align-left text-color-red" v-else>
                  <!-- <a :href="ToolkitFileUrlValue">Download File</a> -->
                  Not available
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc"> 
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="font-size-17px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Created TS:
                </div>
                <div class="font-size-17px col-md-8 col-lg-8 text-align-left">
                  {{formatAndShowDate(CourseCreateTSValue)}}
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc"> 
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="font-size-17px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Updated TS:
                </div>
                <div class="font-size-17px col-md-8 col-lg-8 text-align-left">
                  {{formatAndShowDate(CourseUpdatedTSValue)}}
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc" v-if="isComingFrom === constants.CourseSearchBarEnum.Course">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="font-size-17px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Lesson Numbering:
                </div>
                <div class="font-size-17px col-md-8 col-lg-8 text-align-left">
                  {{LessonNumberValue}}
                </div> 
                <div class="col-md-1 col-lg-1">
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc" v-if="isComingFrom === constants.CourseSearchBarEnum.Course"> 
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="font-size-17px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Course Image:
                </div>
                <div class="col-md-4 col-lg-4 text-align-left">
                  <img :src="CourseImageUrlValue" class="course-img-width-height" id="courseImg" @error="assignDefaultImage" @load="imageLoadedSuccessfully"/>
                </div>
                <div class="col-md-2 col-lg-2">
                  <a type="button" class="btn btn-default btn-sm" v-if="showCourseImgDeleteOption" @click="downloadCourseImage">
                    <span class="glyphicon glyphicon-download"></span> Download
                  </a>
                </div>
                <div class="col-md-2 col-lg-2">
                </div>
              </div>
              <div class="row margin-bottom-2Perc">
                <div class="col-md-5 col-lg-5">
                </div>  
                <div class="col-md-2 col-lg-2">
                  <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="udpateCloseViewCourseDetailOverlay($event)">Done</button>
                </div>  
                <div class="col-md-5 col-lg-5">
                </div>
              </div>
              <div class="row">
              </div>         
          </div>
      </div>
    </div> 
</template>
<script>
import { constants } from '@/utils/constants'
import server from '@/utils/server'
import ErrorImage from '../assets/images/imagenotfound.svg'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
export default {
  props: ['selectedCourseObj', 'isComingFrom'],
  name: 'view-course-details',
  created () {},
  data: function () {
    return {
      constants: constants,
      LessonNumbering: 0,
      showCourseImgDeleteOption: false,
      reAssignedDefaultImg: false
    }
  },
  components: {},
  methods: {
    downloadCourseImage: function () {
      var pom = document.createElement('a')
      pom.setAttribute('href', 'data:application/octet-stream,' + encodeURIComponent(this.CourseImageUrlValue))
      pom.setAttribute('download', this.getCurrentCourseObj.CourseTitle)
      pom.style.display = 'none'
      document.body.appendChild(pom)
      pom.click()
      document.body.removeChild(pom)
    },
    imageLoadedSuccessfully: function () {
      if (!this.reAssignedDefaultImg) {
        this.showCourseImgDeleteOption = true
        console.log('imageLoadedSuccessfully')
      }
    },
    formatAndShowDate: function (date) {
      var dateToPass = date
      if (dateToPass.indexOf('Z') === -1) {
        dateToPass += 'Z'
      }
      return dmAdminUtils.covertUtcToEst(dateToPass)
    },
    udpateCloseViewCourseDetailOverlay: function (event) {
      // AK: Enable Background scrolling
      this.$store.state.isOverlayVisible = false
      this.$emit('closeViewCourse', false)
    },
    assignDefaultImage: function (event) {
      this.showCourseImgDeleteOption = false
      this.reAssignedDefaultImg = true
      document.getElementById('courseImg').src = ErrorImage
    }
  },
  computed: {
    CourseTitleValue: {
      get: function () {
        return this.selectedCourseObj.CourseTitle
      }
    },
    CourseVersionValue: {
      get: function () {
        return this.selectedCourseObj.Version
      }
    },
    CourseTypeValue: {
      get: function () {
        var courseType = parseInt(this.selectedCourseObj.Type)
        var courseTypeName = 'Normal'
        if (courseType === constants.CourseType.M365) {
          courseTypeName = 'Mentora Moments'
        }
        return courseTypeName
      }
    },
    LessonNumberValue: {
      get: function () {
        var LessonNumbering = parseInt(this.selectedCourseObj.Numbering)
        if (LessonNumbering === constants.LessonNumberingType.Custom) {
          LessonNumbering = 'Custom'
        } else if (LessonNumbering === constants.LessonNumberingType.Hide) {
          LessonNumbering = 'Hide'
        } else {
          LessonNumbering = 'Default'
        }
        return LessonNumbering
      }
    },
    CourseSubTitleValue: {
      get: function () {
        return this.selectedCourseObj.SubTitle
      }
    },
    IsEnabledCourseValue: {
      get: function () {
        return this.selectedCourseObj.IsEnabled
      }
    },
    ToolkitFileUrlValue: {
      get: function () {
        return this.selectedCourseObj.ToolkitFileUrl
      }
    },
    CourseCreateTSValue: {
      get: function () {
        return this.selectedCourseObj.CreatedTS
      }
    },
    CourseUpdatedTSValue: {
      get: function () {
        return this.selectedCourseObj.UpdatedTS
      }
    },
    CourseMasterIdValue: {
      get: function () {
        return this.selectedCourseObj.CourseMasterId
      }
    },
    CourseDescriptionValue: {
      get: function () {
        return this.selectedCourseObj.Description
      }
    },
    CourseImageUrlValue: {
      get: function () {
        return server.baseURL() + '/api/CourseMaster/CourseImage?CourseMasterId=' + this.CourseMasterIdValue + '&' + Math.random()
      }
    }
  }
}
</script>

<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.white-BG {
  background-color: #ffffff;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}

.overlay-content {
  position: relative;
  top: 15%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.background-color-white {
  background-color: #ffffff !important;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.center-aligned-div {
  margin: 0 auto;
}
/*
.overlay a {
  padding: 8px;
  text-decoration: none;
  font-size: 36px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

.overlay a:hover,
.overlay a:focus {
  color: #f1f1f1;
}
*/
.overlay .closebtn {
  position: absolute;
  top: 20px;
  right: 45px;
  font-size: 60px;
}
@media screen and (max-height: 450px) {
  /*.overlay a {
    font-size: 20px;
  }*/
  .overlay .closebtn {
    font-size: 40px;
    top: 15px;
    right: 35px;
  }
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.text-align-right {
  text-align: right;
}
.margin-right-1Point2Perc {
  margin-right: 1.2%;
}
.width {
  width: 95%;
}
.create-lesson {
  overflow-y: hidden !important;
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.padding-Top-2Perc {
  padding-top: 2%;
}
.padding-Top-3Perc {
  padding-top: 3%;
}
.font-size-1-3vw {
  font-size: 1.3vw;
}
.font-size-17px {
  font-size: 17px !important;
}
.text-align-left {
  text-align: left !important;
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}

.icon-addon {
  position: relative;
  color: #555;
  display: block;
}

.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}

.icon-addon:after {
  clear: both;
}

.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}

.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 10px 16px 10px 40px;
}

.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}

.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}

.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}

.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
.background-gray {
  background-color: #ddd;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.gray-border {
  border: 1px solid #aaa;
}
.lesson-box-border {
  border: 1px solid #dddddd;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.center-align-div {
  margin: 0 auto;
}
.margin-left-3Perc {
  margin-left: 3% !important;
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 23px;
  width: 23px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #32cd32;
}

input:focus + .slider {
  box-shadow: 0 0 1px #32cd32;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.border-color-red {
  border: 1px solid red;
}
.text-color-red {
  color: red;
}
.border-color-yellow {
  border: 1px solid yellow;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 14px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.margin-bottom-2Perc {
  margin-bottom: 2%;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.create-lesson-overlay-button-width {
  width: 20%;
}
.black-font-color {
  color: #000;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.course-img-width-height {
  width: 350px;
  height: 150px;
}
.margin-top-1Perc {
  margin-top: 1%;
}
.float-right {
  float: right;
}
.font-color-blue {
  color: #34495e;
}
.font-weight-bold {
  font-weight: bold;
}

.margin-right-3Perc {
  margin-right: 3%;
}
.margin-left-2Perc {
  margin-left: 2% !important;
}
.padding-bottom-1Perc {
  padding-bottom: 1%;
}
.bottom-border {
  border-bottom: 1px solid #ddd;
  width: 96%;
}
.font-wight-bold {
  font-weight: bold;
}
.create-element-overlay-course-title-font-styles {
  font-size: 14px;
  color: #34495e;
}
.create-element-overlay-module-title-font-styles {
  font-size: 20px;
  color: #34495e;
}
.margin-Top-1Point5Perc {
  padding-top: 1.5%;
}
.padding-left-4Point4 {
  padding-left: 4.4%;
}
a:link{
  color: #2c3e50 !important;
  text-decoration: none !important;
} 
a:visited{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:hover{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:active{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a {
  color: #2c3e50 !important;
  text-decoration: none !important;
}
.border-red {
  border:1px solid red;
}
</style>


// WEBPACK FOOTER //
// src/components/ViewCourseDetailOverlay.vue